import Vue from 'vue'

export async function getEtapas(context, [access_token, con_loading]) {

    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/etapas',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

            context.commit('etapas/setEtapas', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function crearEtapa(context, [access_token, modelEtapa, camino_id]) {
    try {
        console.log('modelEtapa:', modelEtapa);
        modelEtapa.inicio_punto_id = modelEtapa.inicio_punto.id;
        modelEtapa.final_punto_id = modelEtapa.final_punto.id;
        modelEtapa.camino_id = camino_id;
        console.log('modelEtapa2:', modelEtapa);
       /* if (access_token) {
            // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/etapas',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelEtapa
            })
            if (response.status == 201) {

                context.commit('caminos/actListEtapasFromCaminos', response.data.data, { root: true })
                context.commit('categorias/actListEtapasFromCaminosFromCategorias', response.data.data, { root: true })

            }
            return response;
            
        }*/

    } catch (e) {
    } finally {
        //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateEtapa(context, [access_token, modelEtapa]) {

    try {
        if (access_token) {
            console.log('modelEtapa:', modelEtapa);
            modelEtapa.inicio_punto_id = modelEtapa.inicio_punto.id;
            modelEtapa.final_punto_id = modelEtapa.final_punto.id;
            console.log('modelEtapa2:', modelEtapa);
            const response = await Vue.axios({
                method: 'PUT',
                url: '/etapas/' + modelEtapa.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelEtapa
            })
            if (response.status == 200) {
                context.commit('etapas/actListEtapas', response.data.data, { root: true })
                context.commit('caminos/actListEtapasFromCaminos', response.data.data, { root: true })
                context.commit('categorias/actListEtapasFromCaminosFromCategorias', response.data.data, { root: true })

            }
            console.log('Respuesta de la API:', response);
            return response;
            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarEtapa(context, [access_token, etapa_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/etapas/' + etapa_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })


            if (response.status == 200) {
                context.commit('caminos/actDeleteListEtapas', etapa_id, { root: true })
            }
            return response;

            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}


export async function crearEtapaExtra(context, [access_token, modelEtapaExtra, reserva_id, fecha]) {
    try {
        const response = await Vue.axios({
            method: 'POST',
            url: '/crearEtapaExtra',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            },
            data: modelEtapaExtra
        })
        if (response.status === 200 && response?.data?.reserva) {
            return response.data.reserva;
        }
    } catch (e) {
        console.error('Error al crear la etapa extra:', e);
        throw e;
    }
  }



